export default __webpack_public_path__ + "static/media/passwor-login-banner.137fe30d.png";